import {
  GET_FEATURE_FILE_TYPES,
  GET_FEATURE_FILE_TYPES_FAIL,
  GET_FEATURE_FILE_TYPES_SUCCESS,
  ADD_NEW_FEATURE_FILE_TYPE,
  ADD_FEATURE_FILE_TYPE_SUCCESS,
  ADD_FEATURE_FILE_TYPE_FAIL,
  UPDATE_FEATURE_FILE_TYPE,
  UPDATE_FEATURE_FILE_TYPE_SUCCESS,
  UPDATE_FEATURE_FILE_TYPE_FAIL,
  DELETE_FEATURE_FILE_TYPE,
  DELETE_FEATURE_FILE_TYPE_SUCCESS,
  DELETE_FEATURE_FILE_TYPE_FAIL,
  
} from "./actionTypes";

export const getFeatureFileTypes = () => ({
  type: GET_FEATURE_FILE_TYPES,
})

export const getFeatureFileTypesSuccess = (featureFileTypes) => ({
  type: GET_FEATURE_FILE_TYPES_SUCCESS,
  payload: featureFileTypes,
})

export const getFeatureFileTypesFail = error => ({
  type: GET_FEATURE_FILE_TYPES_FAIL,
  payload: error,
})

export const addNewFeatureFileType = (featureFileType) => ({
  type: ADD_NEW_FEATURE_FILE_TYPE,
  payload: featureFileType,
})

export const addFeatureFileTypeSuccess = (featureFileType) => ({
  type: ADD_FEATURE_FILE_TYPE_SUCCESS,
  payload: featureFileType,
})

export const addFeatureFileTypeFail = error => ({
  type: ADD_FEATURE_FILE_TYPE_FAIL,
  payload: error,
})

export const updateFeatureFileType = (featureFileType) => ({
  type: UPDATE_FEATURE_FILE_TYPE,
  payload: featureFileType,
})

export const updateFeatureFileTypeSuccess = (featureFileType) => ({
  type: UPDATE_FEATURE_FILE_TYPE_SUCCESS,
  payload: featureFileType,
})

export const updateFeatureFileTypeFail = error => ({
  type: UPDATE_FEATURE_FILE_TYPE_FAIL,
  payload: error,
})

export const deleteFeatureFileType = (featureFileType) => ({
  type: DELETE_FEATURE_FILE_TYPE,
  payload: featureFileType,
})

export const deleteFeatureFileTypeSuccess = (featureFileType) => ({
  type: DELETE_FEATURE_FILE_TYPE_SUCCESS,
  payload: featureFileType,
})

export const deleteFeatureFileTypeFail = error => ({
  type: DELETE_FEATURE_FILE_TYPE_FAIL,
  payload: error,
})

